import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../../Services/apiService";

export const GetAllTG_TargetedGroupAge = createAsyncThunk(
  "dropdowns/GetAllTG_TargetedGroupAge",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDowns/GetAllTG_TargetedGroupAge"
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const DropDownTargetedGroupAge = createSlice({
  name: "DropDownTargetedGroupAge",
  initialState: {
    DropDownTargetedGroupAge: [],
    loadingDropDownTargetedGroupAge: false,
    errorDropDownTargetedGroupAge: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllTG_TargetedGroupAge.pending, (state, action) => {
        state.loadingDropDownTargetedGroupAge = true;
        state.DropDownTargetedGroupAge = action.payload;
        state.errorDropDownTargetedGroupAge = null;
      })
      .addCase(GetAllTG_TargetedGroupAge.fulfilled, (state, action) => {
        state.loadingDropDownTargetedGroupAge = false;
        state.DropDownTargetedGroupAge = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllTG_TargetedGroupAge.rejected, (state, action) => {
        state.loadingDropDownTargetedGroupAge = false;
        state.errorDropDownTargetedGroupAge = action.payload;
      });
  },
});

export default DropDownTargetedGroupAge.reducer;
